import React from 'react';
import PropTypes from 'prop-types';
import {useComponentProps} from 'helpers/hooks/utils';
import utils from 'helpers/utils';
import StyledDatabaseEntitiesViewBar
  from 'components/organisms/Bars/DatabaseEntitiesViewBar/DatabaseEntitiesViewBar.styles';

const DatabaseEntitiesViewBar = React.forwardRef((props, ref) => {
  const innerProps = useComponentProps(props, 'DatabaseEntitiesViewBar');

  innerProps.className = utils.flattenClassName(innerProps.className);

  return <StyledDatabaseEntitiesViewBar ref={ref} {...innerProps} />
});

DatabaseEntitiesViewBar.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func
  ])
};

export default DatabaseEntitiesViewBar;
